import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/trades.svg'
import _imports_1 from '../../../../assets/icons/premium-plan.svg'


const _withScopeId = n => (_pushScopeId("data-v-1d623e72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "property_widget_main tw-min-h-[355px] !tw-rounded-[16px]" }
const _hoisted_2 = { class: "property_widget_title" }
const _hoisted_3 = {
  key: 0,
  class: "property_widget tw-min-h-[300px]"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "property_widget_list_left" }
const _hoisted_6 = { class: "tw-min-w-[80px] tw-min-h-[80px] tw-w-[80px] tw-h-[80px] tw-max-h-[80px] tw-rounded-lg tw-overflow-hidden" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "property_widget_list_text" }
const _hoisted_9 = { class: "property_widget_list_type" }
const _hoisted_10 = { class: "property_widget_list_name" }
const _hoisted_11 = { class: "property_widget_list_postcode" }
const _hoisted_12 = { class: "property_widget_list_right" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Trades Icon",
  width: "16",
  height: "16"
}, null, -1))
const _hoisted_14 = {
  key: 1,
  class: "property_widget_manage_property"
}
const _hoisted_15 = {
  key: 2,
  class: "property_widget_premium_main"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "property_widget_premium_icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "property_widget_premium_title" }, "Upgrade to Premium Plan", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "property_widget_premium_des" }, " to manage additional properties, increase document storage capacity, and boost file size limits. ", -1))
const _hoisted_19 = {
  key: 1,
  class: "tw-w-full tw-h-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-3"
}
const _hoisted_20 = { class: "tw-w-full tw-h-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-3" }
const _hoisted_21 = ["src"]

import { LatLngExpression } from "leaflet";
import { ref, onBeforeMount, computed } from "vue";
// import UpgradePremiumWorkstationModal from "@/modules/workstation/propertyowner/pages/UpgradePremiumWorkstationModal.vue";
import PropertyOwnerSubscriptionModal from "@/modules/workstation/propertyowner/pages/PropertyOwnerSubscriptionModal.vue";

import LeafletMap from "@/core/components/map/LeafletMap.vue";
import { PROPERTY_STORE } from "@/store/modules/property";
import { useStore } from "vuex";
import { WORKSTATION } from "@/store/modules/workstation";
import { useRouter } from "vue-router";
import Button from "@/core/components/ui/general/Button.vue";
import Text from "@/core/components/ui/general/Text.vue";
import ToolTip from "@/core/components/common/ToolTip.vue";
import { parseJSON } from "@/core/utils/common";
import { ADD_PROPERTY_ROUTE } from "@/modules/properties/routes";
import { PROPERTY_TYPE } from "@/modules/properties/constants";
import { UserWorkstationSubStatusEnum } from "@/core/enums";


export default /*#__PURE__*/_defineComponent({
  __name: 'PropertiesWidget',
  setup(__props) {

const router = useRouter();
const isShowUpgradePremiumModal = ref(false);
const store = useStore();
const onClickUpgradePlan = () => {
  isShowUpgradePremiumModal.value = true;
};
const closeUpgradePremiumModal = () => {
  isShowUpgradePremiumModal.value = false;
};
const properties = computed(
  () => store.getters[`${PROPERTY_STORE}/properties`]
);

const totalcount = computed(
  () => store.getters[`${PROPERTY_STORE}/totalcount`]
);

const activeUserWorkstation = computed(
  () => store.getters[`${WORKSTATION}/activeUserWorkstation`]
);

const onClickPropertyView = async (id: number) => {
  await router.push({
    name: "propertyDetails",
    params: { propertyId: id },
  });
};

const onClickManageProperty = () => {
  router.push("/properties");
};
const onClickAddProperty = () => {
  router.push({
    name: ADD_PROPERTY_ROUTE,
    params: { type: PROPERTY_TYPE },
  });
};
const getLatLng = (addressData: string): LatLngExpression | undefined => {
  if (!addressData) return undefined;

  try {
    const unParsedData = parseJSON(addressData);
    if (!unParsedData) return undefined;
    const latlng: LatLngExpression = [
      unParsedData.LAT ? unParsedData.LAT : unParsedData.lat,
      unParsedData.LNG ? unParsedData.LNG : unParsedData.lng,
    ];
    return latlng;
  } catch (error) {
    console.error("Invalid address data:", error);
    return undefined;
  }
};

onBeforeMount(() => {
  const checkSubscriptionModal = localStorage.getItem(
    "isShowPOSubScriptionModal"
  );
  if (checkSubscriptionModal) {
    console.log("object");
    isShowUpgradePremiumModal.value = true;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h4", null, "Your Properties (" + _toDisplayString(totalcount.value || "0") + ")", 1),
        _createVNode(ToolTip, { description: "A list of properties you own or manage, where you can oversee ongoing projects, manage contractors, and track progress." })
      ]),
      (properties.value?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(properties.value.slice(0, 2), (property) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "property_widget_list tw-mt-3",
                key: property?.id,
                onClick: ($event: any) => (onClickPropertyView(property?.id))
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    (!property?.propertyImage)
                      ? (_openBlock(), _createBlock(LeafletMap, {
                          key: 0,
                          defaultViewZoom: 17,
                          isDraggable: false,
                          showControls: false,
                          data: [],
                          latlang: getLatLng(property?.addressData)
                        }, null, 8, ["latlang"]))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          class: "tw-w-full tw-h-full",
                          src: property?.publicUrl
                        }, null, 8, _hoisted_7))
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("p", _hoisted_9, _toDisplayString(property?.propertyType), 1),
                    _createElementVNode("h3", _hoisted_10, _toDisplayString(property?.address), 1),
                    _createElementVNode("p", _hoisted_11, [
                      _createVNode(_component_v_icon, { icon: "mdi-map-marker" }),
                      _createTextVNode(_toDisplayString(property?.postcode), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("p", null, _toDisplayString(property?.propertyCategory), 1)
                ])
              ], 8, _hoisted_4))
            }), 128)),
            ((totalcount.value || 0) - 2 > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "more_property_text",
                  onClick: onClickManageProperty
                }, " +" + _toDisplayString(totalcount.value - 2) + "More Properties ", 1))
              : _createCommentVNode("", true),
            (
          activeUserWorkstation.value?.subscription &&
          activeUserWorkstation.value?.subStatus ===
            _unref(UserWorkstationSubStatusEnum).SUCCEEDED
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    onClick: onClickManageProperty
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Manage Properties "),
                      _createVNode(_component_v_icon, { icon: "mdi-chevron-right" })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (
          !activeUserWorkstation.value?.subscription ||
          activeUserWorkstation.value?.subStatus !==
            _unref(UserWorkstationSubStatusEnum).SUCCEEDED
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _hoisted_16,
                  _hoisted_17,
                  _hoisted_18,
                  _createVNode(_component_v_btn, {
                    class: "button button-purple w-auto",
                    onClick: onClickUpgradePlan
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Upgrade Plan ")
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("section", _hoisted_20, [
              _createElementVNode("img", {
                src: require(`@/assets/images/property_empty.png`)
              }, null, 8, _hoisted_21),
              _createVNode(Text, {
                variant: "p",
                textWeight: "600",
                textColor: "rgba(12, 15, 74, 0.5)"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Your added properties will appear here")
                ]),
                _: 1
              }),
              _createVNode(Button, {
                variant: "accent",
                label: "Add Property",
                class: "!tw-w-auto",
                onClick: onClickAddProperty
              })
            ])
          ]))
    ]),
    (isShowUpgradePremiumModal.value)
      ? (_openBlock(), _createBlock(PropertyOwnerSubscriptionModal, {
          key: 0,
          onCloseSubscriptionModal: closeUpgradePremiumModal,
          onCloseSelectWorkstationTypeModal: closeUpgradePremiumModal
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})